type EventId = number;

interface Listener
{
    callback: Function;
    scope: any;
    once: boolean;
}


export class EVENTS
{

    static id: EventId = 0x0;
    static next(): EventId
    {
        return this.id++;
    }

    static listeners: Record<EventId, Array<Listener>> = {};


    static on(event: EventId, callback: Function, scope?: any, prepend: boolean = false, once = false)
    {
        if (!this.listeners[event])
        {
            this.listeners[event] = [];
        }

        if (prepend)
        {
            this.listeners[event].unshift({
                callback: callback,
                scope: scope,
                once: once
            });
        }
        else
        {
            this.listeners[event].push({
                callback: callback,
                scope: scope,
                once: once
            });
        }
    }


    static once(event: EventId, callback: Function, scope?: any, prepend: boolean = false)
    {
        this.on(event, callback, scope, prepend, true);
    }


    static off(event: EventId, callback: Function, scope: any)
    {
        if (this.listeners[event])
        {
            const listenerIdx = this.listeners[event].findIndex(listener => listener.callback === callback && listener.scope === scope);
            if (listenerIdx !== -1)
            {
                this.listeners[event].splice(listenerIdx, 1);
            }
        }
    }


    static emit(event: EventId, ...args: any)
    {
        const listeners = this.listeners[event];
        if (!listeners)
        {
            return;
        }

        for (let i = 0; i < listeners.length; i++)
        {
            const listener = listeners[i];
            listener.callback.call(listener.scope, ...args);

            if (listener.once)
            {
                listeners.splice(i--, 1);
            }
        }
    }


}

export namespace EVENTS
{

    export class RESPONSE
    {
        static MY_BETS_UPDATE = EVENTS.next();
        static ALL_BETS_UPDATE = EVENTS.next();
        static PREVIOUS_BETS_UPDATE = EVENTS.next();
        
        static SOCKET = EVENTS.next();
        
        static PLAYER_UPDATE = EVENTS.next();
    }

    export class SETTINGS
    {
        static MUSIC = EVENTS.next();
        static SOUND = EVENTS.next();
        static ANIMATION = EVENTS.next();
    }

    export class GAME 
    {
        static BET = EVENTS.next();
        static REQUEST_BET = EVENTS.next();
        static LOADED = EVENTS.next();
        static ADD_TO_HISTORY = EVENTS.next();
        static START_AUTOPLAY = EVENTS.next();
        static START_STRATEGY = EVENTS.next();
        static ALERT = EVENTS.next();
        static CRITICAL_ERROR = EVENTS.next();
        static PLAYER_CASHOUT = EVENTS.next();
        
        static PLAYERS_COUNT = EVENTS.next();
        
        static BUTTON_CLICK = EVENTS.next();
    }

    export class UTIL
    {
        static KEYBOARD = EVENTS.next();
    }

    export class PIXI
    {
        static RESIZE = EVENTS.next();
    }

    export class LOADING
    {
        static PROGRESS = EVENTS.next();
        static COMPLETE = EVENTS.next();
        static CLOSED = EVENTS.next();
    }

}